export const getCurrentPosition = () =>
  new Promise((resolve, reject) => {
    if (!window.navigator?.geolocation) {
      reject(new Error('Geolocation API not supported!'));
    }

    // See https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition for docs.
    const options = {
      enableHighAccuracy: true,
      timeout: 10 * 1000, // give up after 10 seconds
    };

    const successCallback = (position) => {
      resolve([position.coords.longitude, position.coords.latitude]);
    };

    const errorCallback = (err) => reject(err);

    window.navigator.geolocation.getCurrentPosition(
      successCallback,
      errorCallback,
      options,
    );
  });
